import * as actionTypes from "./actionTypes";

export const addStoreAction = (store) => {
  return { type: actionTypes.ADD_STORE, store };
};

export const addStoreSuccessAction = (stores) => {
  return { type: actionTypes.ADD_STORE_SUCCESS, stores };
};

export const getStoresAction = (userId) => {
  return { type: actionTypes.GET_STORES, userId };
};

export const getStoresSuccessAction = (stores) => {
  return { type: actionTypes.GET_STORES_SUCCESS, stores };
};

export const editStoreAction = (store) => {
  return { type: actionTypes.EDIT_STORE, store };
};

export const editStoreSuccessAction = (stores) => {
  return { type: actionTypes.EDIT_STORE_SUCCESS, stores };
};

export const deleteStoreAction = (store) => {
  return { type: actionTypes.DELETE_STORE, store };
};

export const deleteStoreSuccessAction = (store) => {
  return { type: actionTypes.DELETE_STORE_SUCCESS, store };
};
